import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Catalogo from '../../components/Catalogo/catalogoNuevo'
import * as catalogoActions from '../../reducers/catalogoReducer/actions'
import * as rubrosActions from '../../reducers/rubrosReducer/actions'
import { catalogoDataSelector } from '../../selectors/catalogoSelector'
import { rubrosDataSelector } from '../../selectors/rubrosSelector'
import * as Notification from '../../components/Common/notification'
import { compress, calculateNewSize } from '../../components/Common/imageCompressor'

class CatalogoContainer extends React.Component{
    constructor(props){
        super(props)

        this.props.sagaGetRubros(null, true, true);
        let payload = {}
        this.props.sagaGetCatalogoByName('')
        
        let catalogoEdicion = {}
        if (this.props.match.params.idCatalogo !== undefined){
        payload.id = this.props.match.params.idCatalogo             
        }

        this.state = {
            catalogo: {
                id: 0,
                nombre: '',
                imgSrc: {},
                descripcion: ''
            },
            saved: false,
            valid : true,
            errorDescription: {},

            openModalImagen: false,
            currentFile:undefined,
            imagenOriginal:undefined,
            
            payloadCatalogo:{},    
            open: false,
            updateIdTemporal: false,
            idTemporal: '',
            update : false,
            catalogoEdicion: catalogoEdicion
        }
    }

    componentWillReceiveProps = (nextProps) => {
        // Para la edicion de catalogo
        if (nextProps.match.params.idCatalogo !== undefined  && this.state.update === false && nextProps.data.catalogos !== undefined){
           let payload = {}
            let catalogoEdicion = {...this.state.catalogoEdicion}
            payload.id = nextProps.match.params.idCatalogo      
            
            catalogoEdicion = nextProps.data.catalogos.filter(function (catalogo) {//Obtengo el catalogo que se esta editando.           
                return (catalogo.idCatalogo === parseInt(payload.id) 
                         )})
                
            let catalogo = {...this.state.catalogo}
            catalogo.nombre = catalogoEdicion[0].nombre
            catalogo.descripcion = catalogoEdicion[0].descripcion
            catalogo.id = catalogoEdicion[0].idCatalogo
            let imagenOriginal = undefined
            if(catalogoEdicion[0].imagenCatalogo !== ""){
                catalogo.imgSrc = {PathImagen: catalogoEdicion[0].imagenCatalogo, Path: catalogoEdicion[0].catalogoImagen[0].path}
            
                imagenOriginal = {...this.state.imagenOriginal}
                imagenOriginal = `data:image/ief;base64,` + catalogoEdicion[0].imagenCatalogo
                
                // Llevamos la imagen al temporal
                let data = {}
                data.idTemporal =this.state.idTemporal
                data.idCatalogo = catalogo.id
                
                nextProps.setImagenCatalogoToTemp(data)
            }

            /*catalogo.imgSrc = {PathImagen: catalogoEdicion[0].imagenCatalogo, Path: catalogoEdicion[0].catalogoImagen[0].path}
            
            let imagenOriginal = {...this.state.imagenOriginal}
            imagenOriginal = `data:image/ief;base64,` + catalogoEdicion[0].imagenCatalogo
            
            // Llevamos la imagen al temporal
            let data = {}
            data.idTemporal =this.state.idTemporal
            data.idCatalogo = catalogo.id
            
            nextProps.setImagenCatalogoToTemp(data)*/

            this.setState({
                catalogoEdicion:catalogoEdicion,
                catalogo,
                imagenOriginal,
                update: true
            })
        }
    }

    componentWillMount = (props) => {
        if (this.state.catalogo !== undefined && this.state.updateIdTemporal === false){
            this.setState({
                updateIdTemporal: true,
                idTemporal: Math.floor(1000 + Math.random() * 9000)    
            })
        }
    }

    handleOnChangeNombre = (event) => {

        let catalogo = {...this.state.catalogo}
        catalogo.nombre = event.target.value
        this.setState({ catalogo: catalogo })
    }

    handleOnChangeDescripcion = (event) => {
        let catalogo = {...this.state.catalogo}
        catalogo.descripcion = event.target.value
        this.setState({ catalogo: catalogo })
    }

    onImageCompressed = (currentFile) => {
        
        this.props.sagaSaveImagenCatalogo({ 
            currentFile: currentFile,
            idTemporal: this.state.idTemporal,
            original: true
        })  

        //guardo en el estado una copia, para usarla al momento de guardar los recortes
        let currentFileCopy = currentFile
        let file = URL.createObjectURL(currentFile)
    
        //Agrego un prefijo para poder obtenerla luego. En la imagenHelper le agrego el prefijo antes de guardar, ya que el campo name del currentFile es read only
        let newImgSrc = {Path: "original_"+ currentFile.name, selected: false, idArticuloImagenes:0, Orden: 1, Miniatura: false, PathImagen: file}    
        let catalogo = {...this.state.catalogo}            
        catalogo.imgSrc = newImgSrc
        this.setState({
            catalogo: catalogo,
            imagenOriginal: newImgSrc.PathImagen,
            currentFile: currentFileCopy
            //openModalImagen:true
        })
    }

    handleOnDropFile = (acceptedFiles, rejectedFiles) => {
        
        
        if (rejectedFiles.length !== 0){
            if (rejectedFiles.length === 1) Notification.showError("Formato de Imagen no aceptado.")
            if (rejectedFiles.length > 1) Notification.showError("Se permite solo una imagen como portada de catálogo.")

        }
        else{
            if (acceptedFiles.length !== 0) {
                
                let currentFile = acceptedFiles[0]

                // genero una imagen para conocer sus dimesiones
                let _self = this
                let img = new Image()
                img.onload = function () {
                    
                    // comprimo la imagen
                    let newSize = calculateNewSize(this.width, this.height, 750*2, 1125*2)
                    compress(currentFile, currentFile.name, newSize.width, newSize.height, _self.onImageCompressed)
                }
                img.src = URL.createObjectURL(currentFile)
            }
        }                
    }

    handleCancelButton = () => {
        this.setState({open:false})
    }

    handleCloseDialog = () => {


        this.setState({
            saved:false
        })

            this.props.history.push({
            pathname: '/Articulo/articuloNuevo',
            idCatalogo:  this.props.data.idCatalogo,
            payloadRubro: this.props.dataRubros.rubros[0].idRubro
              })
    }

    validar = () => {
        let catalogo= {...this.state.catalogo}
        let errorDescription = {} //segui aca con el validar de catalogo
        let valid = true
        
        if (catalogo.nombre === ''){
            valid = false
            errorDescription.errorNombre="Por favor ingrese un nombre válido"    
        }
        
        if (catalogo.nombre.length > 255){
            valid = false
            Notification.showError('Exceso de caracteres en campo')
        }
        
        if (catalogo.descripcion.length > 255){
            valid = false
            Notification.showError('Exceso de caracteres en campo')
        }

            return {valid, errorDescription}
    }

    handleOnSave = (event) => {
        // armo el payload para guardar el catálogo
        let savePayload = {}
        savePayload.Id = this.state.catalogo.id
        savePayload.IdInstalacion = 1 // Instalacion 1 Mockeada
        savePayload.UsuarioRegistro = 'b242a843-e91e-4c65-970a-f4b6747485fc' // TODO
        savePayload.Activo = 1 // Cuando se crea un catalogo se registra activo
        savePayload.FechaRegistro = new Date()
        savePayload.Nombre = this.state.catalogo.nombre
        savePayload.Descripcion = this.state.catalogo.descripcion
        savePayload.CatalogoImagenes = this.state.catalogo.imgSrc
        savePayload.idTemporal = this.state.idTemporal

        this.handleOnConfirmedSave(savePayload)
    }

    handleOnConfirmedSave = (savePayload) => {
        let valido = this.validar()
        
        if (valido.valid === true){
            savePayload.callback = (idCatalogo) => {
                if (this.props.dataRubros.rubros.length > 1){
                    this.setState({    
                        open: true,
                        valid:true,
                        payloadCatalogo: savePayload,
                        saved:true
                            })
                        }
                else{
                    this.setState({    
                        open: false,
                        valid:true,
                        payloadCatalogo: savePayload,
                        saved:true
                            })
                        if(this.props.data.catalogoCompleto === undefined){ //Si estamos en una edicion nos vamos a la pantalla de edicion, si es catalogo nuevo vamos a agregar articulo
                            this.props.history.push({
                                pathname: '/Articulo/articuloNuevo/' + idCatalogo,
                                idCatalogo:  this.props.data.idCatalogo,
                                payloadRubro: this.props.dataRubros.rubros[0].idRubro
                            })  
                        } else {
                            this.props.history.push(`/Catalogo/catalogoEdicion/${this.props.data.catalogoCompleto.idCatalogo}`)                              
                        }
                                                
                    }
            }
            this.props.sagaSaveCatalogo(savePayload)
            //Notification.showSuccess("Catalogo Creado")
        }
        else{
            this.setState({    
                open: false,
                valid:false
        })
            }        

    }

    handleOnCloseCropperModal = () => {
        this.setState({openModalImagen:false})
    }

    handleOnOpenCropperModal = () => {
        this.setState({openModalImagen:true})
    }

    onRecorteImagenCompressed = (currentFile) => {
       
        // guardo el recorte
        this.props.sagaSaveImagenCatalogo({ 
            currentFile: currentFile, 
            idTemporal: this.state.idTemporal, 
            original: false 
        })
        
        // genero el image source
        let recorte = URL.createObjectURL(currentFile)
        let newImgSrc = { 
            Path: this.props.data.catalogoCompleto === undefined ? this.state.currentFile.name : currentFile.name, 
            selected: false, 
            idArticuloImagenes: 0, 
            Orden: 1, 
            Miniatura: false, 
            PathImagen: recorte
        }
        
        // actualizo el catálogo
        let catalogo = {...this.state.catalogo}            
        catalogo.imgSrc = newImgSrc
        this.setState({
            catalogo : catalogo,
            openModalImagen: false,
        })
    }

    handleOnSaveImagenCortada = (recorte, blobData, imageData) => {
        
        // obtengo el nombre de archivo. Si se trata de edicion voy al state catalogo.

        let fileName = this.state.currentFile !== undefined ? this.state.currentFile.name : this.state.catalogo.imgSrc.Path;

        // comprimo la imagen
        let newSize = calculateNewSize(imageData.width, imageData.height, 350*2, 525*2)
        compress(blobData, fileName, newSize.width, newSize.height, this.onRecorteImagenCompressed)
    }

    render() {
        
        return ( 
            <Catalogo 
                handleCancelButton = {this.handleCancelButton}
                open = {this.state.open}
                catalogo={this.state.catalogo}
                handleOnChangeNombre={this.handleOnChangeNombre}
                handleOnChangeDescripcion={this.handleOnChangeDescripcion}                   
                handleOnDropFile={this.handleOnDropFile}
                handleOnSave={this.handleOnSave}
                handleOnCancel={this.handleOnCancel}
                payloadCatalogo = {this.state.payloadCatalogo}
                idCatalogo = {this.props.data.idCatalogo}
                errorDescription = {this.state.errorDescription}
                valid = {this.state.valid}
                saved = {this.state.saved}
                handleCloseDialog = {this.handleCloseDialog}
                edicion = {this.props.data.catalogoCompleto !== undefined ? true: false}

                openModalImagen = {this.state.openModalImagen}
                handleOnCloseCropperModal={this.handleOnCloseCropperModal}
                handleOnOpenCropperModal={this.handleOnOpenCropperModal}
                handleOnSaveImagenCortada={this.handleOnSaveImagenCortada}
                imagenOriginal={this.state.imagenOriginal}
            />
        )}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
        ...catalogoActions,
        ...rubrosActions
	}, dispatch)
}

function mapStateToProps(state) {
	return {
        data: catalogoDataSelector(state),
        dataRubros: rubrosDataSelector(state)
        
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(CatalogoContainer)